import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { LinearProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    progressBar: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 4,
        zIndex: 9999,
        backgroundColor: "transparent",
        "& .MuiLinearProgress-bar": {
            backgroundColor: theme.palette.primary.main,
        },
    },
}));

export const ScrollProgress = () => {
    const classes = useStyles();
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const updateScrollProgress = () => {
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollableHeight = documentHeight - windowHeight;
            const progress = scrollableHeight > 0 ? (scrollTop / scrollableHeight) * 100 : 0;
            setScrollProgress(progress);
        };

        window.addEventListener("scroll", updateScrollProgress);
        updateScrollProgress(); // Initial call

        return () => {
            window.removeEventListener("scroll", updateScrollProgress);
        };
    }, []);

    return (
        <LinearProgress
            variant="determinate"
            value={scrollProgress}
            className={classes.progressBar}
        />
    );
};

